import React, { useState, useEffect } from "react";
import {
  Box,
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  Flex,
  useColorModeValue,
  HStack,
  IconButton,
  Text,
  Input,
  InputGroup,
  InputLeftElement,
} from "@chakra-ui/react";
import { FaSearch, FaBell, FaCog } from "react-icons/fa";
import UserMenu from "./UserMenu";

function AdminNavbarLinks() {
  const navbarIcon = useColorModeValue("gray.500", "gray.200");
  const searchBg = useColorModeValue("white", "gray.700");
  const searchBorder = useColorModeValue("gray.200", "gray.600");

  return (
    <HStack spacing={{ base: "2", md: "4" }}>
      <InputGroup
        display={{ base: "none", md: "flex" }}
        w="200px"
      >
        <InputLeftElement>
          <IconButton
            bg="inherit"
            borderRadius="inherit"
            _hover="none"
            _active={{ bg: "inherit", transform: "none", borderColor: "transparent" }}
            _focus={{ boxShadow: "none" }}
            icon={<FaSearch color={navbarIcon} w="15px" h="15px" />}
            aria-label="جستجو"
          />
        </InputLeftElement>
        <Input
          fontSize="xs"
          py="11px"
          bg={searchBg}
          placeholder="جستجو در پنل..."
          borderRadius="15px"
          border="1px solid"
          borderColor={searchBorder}
          _focus={{ borderColor: "blue.400", boxShadow: "none" }}
        />
      </InputGroup>

      <IconButton
        variant="ghost"
        color={navbarIcon}
        icon={<FaBell size="18" />}
        borderRadius="xl"
        aria-label="اعلان‌ها"
      />
      <IconButton
        variant="ghost"
        color={navbarIcon}
        icon={<FaCog size="18" />}
        borderRadius="xl"
        aria-label="تنظیمات"
      />

      <UserMenu />
    </HStack>
  );
}

// ==========================================
// 🏛️ کامپوننت اصلی هدر (AdminNavbar)
// ==========================================
export default function AdminNavbar(props) {
  const [scrolled, setScrolled] = useState(false);
  const { brandText } = props;

  // مدیریت وضعیت اسکرول برای تغییر استایل هدر
  useEffect(() => {
    const changeNavbarVariant = () => {
      if (window.scrollY > 10) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };
    window.addEventListener("scroll", changeNavbarVariant);
    return () => window.removeEventListener("scroll", changeNavbarVariant);
  }, []);

  // 🎨 تنظیمات رنگی و استایل شیشه‌ای (Glassmorphism)
  const mainText = useColorModeValue("gray.700", "white");
  const secondaryText = useColorModeValue("gray.400", "gray.400");
  
  // استایل هدر در حالت اسکرول شده
  const navbarBg = useColorModeValue(
    "rgba(255, 255, 255, 0.8)", 
    "rgba(26, 32, 44, 0.8)"
  );
  const navbarShadow = useColorModeValue(
    "0px 7px 23px rgba(0, 0, 0, 0.05)",
    "0px 7px 23px rgba(0, 0, 0, 0.4)"
  );
  const navbarBorder = useColorModeValue("gray.100", "whiteAlpha.100");

  return (
    <Flex
      position="relative"
      w="100%"
      transition="all 0.25s ease-in-out"
      alignItems="center"
      p={{ base: "8px", md: "12px" }}
      borderRadius="24px"
      zIndex="1100"
      dir="rtl"
      bg={scrolled ? navbarBg : "transparent"}
      boxShadow={scrolled ? navbarShadow : "none"}
      border={scrolled ? "1px solid" : "none"}
      borderColor={navbarBorder}
      backdropFilter={scrolled ? "blur(15px)" : "none"}
    >
      <Flex
        w="100%"
        flexDirection={{ base: "column", md: "row" }}
        alignItems={{ base: "flex-start", md: "center" }}
        justifyContent="space-between"
        gap={{ base: 3, md: 0 }}
      >
        {/* بخش راست: Breadcrumb و عنوان صفحه */}
        <Box textAlign="right" flex="1" minW={0}>
          <Breadcrumb fontSize="xs" mb="1" separator="/">
            <BreadcrumbItem color={secondaryText} isCurrentPage={false}>
              <BreadcrumbLink href="#" _hover={{ color: "blue.500" }}>
                صفحات
              </BreadcrumbLink>
            </BreadcrumbItem>
            <BreadcrumbItem color={mainText} isCurrentPage>
              <BreadcrumbLink href="#" fontWeight="bold">
                {brandText}
              </BreadcrumbLink>
            </BreadcrumbItem>
          </Breadcrumb>
          
          <Text
            color={mainText}
            fontWeight="black"
            fontSize={{ base: "lg", md: "xl" }}
            letterSpacing="tight"
          >
            {brandText}
          </Text>
        </Box>

        {/* بخش چپ: جستجو و آیکون‌ها */}
        <Box flexShrink={0}>
          <AdminNavbarLinks />
        </Box>
      </Flex>
    </Flex>
  );
}